export default {"src":"/_next/static/media/EHBO.2e86808f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};